import { render, staticRenderFns } from "./CustomerRelationship.vue?vue&type=template&id=3fdc9017&scoped=true&"
import script from "./CustomerRelationship.vue?vue&type=script&lang=js&"
export * from "./CustomerRelationship.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRelationship.vue?vue&type=style&index=0&id=3fdc9017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc9017",
  null
  
)

export default component.exports